<template>
  <div>
    <div v-if="this.language == 1">
      <div>
        <div v-if="this.current>1" style="position:absolute;top:50px; right:50px">
          <img @click="slide(1)" src="../assets/zimes/4.png">
        </div>
        <div v-if="this.current == 1" style="position:absolute;top:50px; right:50px">
          <img @click="slide(0)" src="../assets/zimes/4.png">
        </div>
      </div>
      <div class="home-menu-outer" v-show="this.current > 0 ">
        <a @click="prevSlide()" v-show="this.current > 1 && this.current < 10">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/6.png">
        </a>
        <a @click="prevSlide()" v-show="this.current > 9">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/8.png">
        </a>
        <div class="inner">
          <a>
            <img @click="homeSlide()" src="../assets/zimes/home.png">
          </a>
          <a>
            <img src="../assets/zimes/divider.png">
          </a>
          <a style="position:relative;">
            <img @click="menu()" src="../assets/zimes/menu.png">
            <div class="sub-menu" v-if="this.showMenu == 1">
              <ul>
                <a @click="slide(1)">
                  <li>Laika līnija</li>
                </a>
                <span>ATMODAS CEĻŠ</span>
                <a @click="slide(3)">
                  <li>Brāļu draudzes - latviešu garīgās atmodas pirmsākums</li>
                </a>
                <a @click="slide(2)">
                  <li>Dzimtbūšanas atcelšana Vidzemē</li>
                </a>

                <a @click="slide(4)">
                  <li>Izglītoto zemnieku dzimtu veidošanās pēc dzimtbūšanas atcelšanas Vidzemē</li>
                </a>
                <a @click="slide(5)">
                  <li>Tautai kopīgu tradīciju veidošanās</li>
                </a>
                <a @click="slide(6)">
                  <li>Tartu (Tērbatas) Universitāte - jaunlatviešu kustības dzimšanas vieta</li>
                </a>
                <a @click="slide(7)">
                  <li>Jaunlatvieši un latviešu valoda</li>
                </a>
                <a @click="slide(8)">
                  <li>Jaunlatvieši Krievijā</li>
                </a>
                <a @click="slide(9)">
                  <li>Jaunlatvieši un atmoda</li>
                </a>
                <span>Atmodas simboli</span>
                <a @click="slide(10)">
                  <li>Dziesmu svētki</li>
                </a>
                <a @click="slide(11)">
                  <li>Himna</li>
                </a>
                <a @click="slide(12)">
                  <li>Latviešu tautas dziesmas un Dainu skapis</li>
                </a>
                <a @click="slide(13)">
                  <li>Karogs</li>
                </a>
              </ul>
            </div>
          </a>
        </div>
        <a @click="nextSlide()" v-show="this.current > 1 && this.current < 10">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/7.png">
        </a>
        <a @click="nextSlide()" v-show="this.current > 9">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/9.png">
        </a>
      </div>
      <div class="home-menu-outer" v-show="this.current == 0 ">
        <div class="inner">
          <a>
            <img @click="setLanguage(1)" src="../assets/zimes/lv.png">
          </a>
          <a>
            <img @click="setLanguage(2)" src="../assets/zimes/eng.png">
          </a>
          <a>
            <img src="../assets/zimes/divider.png">
          </a>
          <a style="position:relative">
            <img @click="menu()" src="../assets/zimes/menu.png">
            <div class="sub-menu" v-show="this.showMenu == 1">
              <ul>
                <a @click="slide(1)">
                  <li>Laika līnija</li>
                </a>
                <span>ATMODAS CEĻŠ</span>
                <a @click="slide(3)">
                  <li>Brāļu draudzes - latviešu garīgās atmodas pirmsākums</li>
                </a>
                <a @click="slide(2)">
                  <li>Dzimtbūšanas atcelšana Vidzemē</li>
                </a>

                <a @click="slide(4)">
                  <li>Izglītoto zemnieku dzimtu veidošanās pēc dzimtbūšanas atcelšanas Vidzemē</li>
                </a>
                <a @click="slide(5)">
                  <li>Tautai kopīgu tradīciju veidošanās</li>
                </a>
                <a @click="slide(6)">
                  <li>Tartu (Tērbatas) Universitāte - jaunlatviešu kustības dzimšanas vieta</li>
                </a>
                <a @click="slide(7)">
                  <li>Jaunlatvieši un latviešu valoda</li>
                </a>
                <a @click="slide(8)">
                  <li>Jaunlatvieši Krievijā</li>
                </a>
                <a @click="slide(9)">
                  <li>Jaunlatvieši un atmoda</li>
                </a>
                <span>Atmodas simboli</span>
                <a @click="slide(10)">
                  <li>Dziesmu svētki</li>
                </a>
                <a @click="slide(11)">
                  <li>Himna</li>
                </a>
                <a @click="slide(12)">
                  <li>Latviešu tautas dziesmas un Dainu skapis</li>
                </a>
                <a @click="slide(13)">
                  <li>Karogs</li>
                </a>
              </ul>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!--eng menu -->
    <div v-if="this.language== 2">
      <div>
        <div v-if="this.current>1" style="position:absolute;top:50px; right:50px">
          <img @click="slide(1)" src="../assets/zimes/4.png">
        </div>
        <div v-if="this.current == 1" style="position:absolute;top:50px; right:50px">
          <img @click="slide(0)" src="../assets/zimes/4.png">
        </div>
      </div>
      <div class="home-menu-outer" v-show="this.current > 0 ">
        <a @click="prevSlide()" v-show="this.current > 1 && this.current < 10">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/6.png">
        </a>
        <a @click="prevSlide()" v-show="this.current > 9">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/8.png">
        </a>
        <div class="inner">
          <a>
            <img @click="homeSlide()" src="../assets/zimes/home.png">
          </a>
          <a>
            <img src="../assets/zimes/divider.png">
          </a>
          <a style="position:relative;">
            <img @click="menu()" src="../assets/zimes/menu.png">
            <div class="sub-menu" v-if="this.showMenu == 1">
              <ul>
                <a @click="slide(1)">
                  <li>Timeline</li>
                </a>
                <span>THE ROAD OF THE AWAKENING</span>
                <a @click="slide(3)">
                  <li>Unity of the brethren – beginning of the latvian national awakening</li>
                </a>
                <a @click="slide(2)">
                  <li>Abolition of serfdom in Vidzeme</li>
                </a>

                <a @click="slide(4)">
                  <li>Formation of educated farmers families after abolition of serfdom in vidzeme</li>
                </a>
                <a @click="slide(5)">
                  <li>Formation of shared traditions</li>
                </a>
                <a @click="slide(6)">
                  <li>Tartu (Tērbata) University – place of birth of the Young Latvian movement</li>
                </a>
                <a @click="slide(7)">
                  <li>Young Latvians and latvian language</li>
                </a>
                <a @click="slide(8)">
                  <li>Young Latvians in st. Petersburg and Moscow</li>
                </a>
                <a @click="slide(9)">
                  <li>Young Latvians and The Awakening</li>
                </a>
                <span>SYMBOLS OF THE NATIONAL AWAKENING</span>
                <a @click="slide(12)">
                  <li>Song celebration</li>
                </a>
                <a @click="slide(11)">
                  <li>Hymn</li>
                </a>
                <a @click="slide(13)">
                  <li>Latvian folk songs and the Cabinet of Folksongs (Dainu skapis)</li>
                </a>
                <a @click="slide(10)">
                  <li>The Flag</li>
                </a>
              </ul>
            </div>
          </a>
        </div>
        <a @click="nextSlide()" v-show="this.current > 1 && this.current < 10">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/7.png">
        </a>
        <a @click="nextSlide()" v-show="this.current > 9">
          <img class="animated animated pulse infinite slow" src="../assets/zimes/9.png">
        </a>
      </div>
      <div class="home-menu-outer" v-show="this.current == 0 ">
        <div class="inner">
          <a>
            <img @click="setLanguage(1)" src="../assets/zimes/lv.png">
          </a>
          <a>
            <img @click="setLanguage(2)" src="../assets/zimes/eng.png">
          </a>
          <a>
            <img src="../assets/zimes/divider.png">
          </a>
          <a style="position:relative">
            <img @click="menu()" src="../assets/zimes/menu.png">
            <div class="sub-menu" v-show="this.showMenu == 1">
              <ul>
                <a @click="slide(1)">
                  <li>Timeline</li>
                </a>
                <span>THE ROAD OF THE AWAKENING</span>
                <a @click="slide(3)">
                  <li>Unity of the brethren – beginning of the latvian national awakening</li>
                </a>
                <a @click="slide(2)">
                  <li>Abolition of serfdom in Vidzeme</li>
                </a>

                <a @click="slide(4)">
                  <li>Formation of educated farmers families after abolition of serfdom in vidzeme</li>
                </a>
                <a @click="slide(5)">
                  <li>Formation of shared traditions</li>
                </a>
                <a @click="slide(6)">
                  <li>Tartu (Tērbata) University – place of birth of the Young Latvian movement</li>
                </a>
                <a @click="slide(7)">
                  <li>Young Latvians and latvian language</li>
                </a>
                <a @click="slide(8)">
                  <li>Young Latvians in st. Petersburg and Moscow</li>
                </a>
                <a @click="slide(9)">
                  <li>Young Latvians and The Awakening</li>
                </a>
                <span>SYMBOLS OF THE NATIONAL AWAKENING</span>
                <a @click="slide(12)">
                  <li>Song celebration</li>
                </a>
                <a @click="slide(11)">
                  <li>Hymn</li>
                </a>
                <a @click="slide(13)">
                  <li>Latvian folk songs and the Cabinet of Folksongs (Dainu skapis)</li>
                </a>
                <a @click="slide(10)">
                  <li>The Flag</li>
                </a>
              </ul>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      current: 0,
      showMenu: 0,
      language: 1
    };
  },

  created() {
    this.$eventHub.$on("slide-changed", count => {
      this.showMenu = 0;
      this.current = count;
    });
  },
  methods: {
    menu: function() {
      if (this.showMenu == 0) {
        this.showMenu = 1;
      } else {
        this.showMenu = 0;
      }
    },
    nextSlide: function() {
      this.showMenu = 0;
      this.$eventHub.$emit("next-slide", this.current + 1);
    },
    prevSlide: function() {
      this.showMenu = 0;
      this.$eventHub.$emit("prev-slide", this.current - 1);
    },
    homeSlide: function() {
      this.showMenu = 0;
      this.current = 0;
      this.$eventHub.$emit("home-slide", 0);
    },
    slide: function(n) {
      this.showMenu = 0;
      this.current = n;
      this.$eventHub.$emit("slide", n);
    },
    setLanguage: function(val) {
      this.language = val;
      this.$eventHub.$emit("language", val);
    }
  }
};
</script>
<style lang="scss">
.sub-menu {
  position: absolute;
  bottom: 70px;
  left: 0px;
  background: rgba(254, 245, 217, 0.9);
  a {
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    padding: 20px;
    width: 300px;
    text-align: left;
    li {
      text-decoration: underline;

      padding: 10px;
    }
    span {
      text-transform: uppercase;
      text-align: center;
      display: block;
      padding: 10px;
      position: relative;
      &::after {
        display: block;
        content: "";
        width: 70%;

        height: 1px;
        background: black;
        position: absolute;
        bottom: 0;
        left: 15%;
        margin: auto !important;
      }
      &::before {
        display: block;
        content: "";
        width: 70%;

        height: 1px;
        background: black;
        position: absolute;
        top: 0px;
        left: 15%;
        margin: auto !important;
      }
    }
  }
}
.menu {
  position: absolute;
  bottom: 25px;
  text-align: center;
  width: 100%;
  line-height: 1;
}
.home-menu-outer {
  position: absolute;
  bottom: 25px;
  width: 100%;
  text-align: center;
  width: 100%;

  text-align: center;
  .inner {
    padding: 7px;
    padding-left: 50px;
    padding-right: 50px;
    border-radius: 40px;
    display: inline-block;
    background-color: rgba(192, 181, 169, 1);
  }
  a > img {
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
}
</style>
